// ErrorBanner — Presentational error banner for the FlightLookup panel.
//
// Extracted verbatim from `FlightLookup.js` as part of the behavior-preserving
// refactor (issue #240). Render-only, wrapped in React.memo. Preserves the
// source's `if (!error) return null;` render guard so nothing is emitted when
// there is no error, and the banner markup/styles are identical to the source.
//
// Props:
//   error - error message string; when falsy the component renders nothing
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';

export const ErrorBanner = React.memo(function ErrorBanner({ error }) {
  if (!error) return null;
  return (
    <div style={{
      padding: '12px',
      background: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '8px',
      color: '#dc2626',
      fontSize: '14px',
      marginBottom: '16px'
    }}>
      {error}
    </div>
  );
});

export default ErrorBanner;
